import * as angular from 'angular';

import { ModalType } from '@mode/shared/ui-angularjs';
import { getAppName } from '@mode/shared/util-js';

export class ConnectionEncryptionToggleController {
  readonly appName = getAppName();
  private checked: boolean;
  private bridged: boolean;
  private sslOptional: boolean;
  private desc =
    'If disabled, connections between the Bridge connector and your database will not be encrypted. We strongly recommend using transport encryption.';
  private confirmButtonConfirm = 'Turn it off';
  private confirmButtonCancel = 'Cancel';
  private confirmContent = `
    <h1>Turn off transport encryption?</h1>
    <p>
      Connecting to some databases may require disabling
      transport encryption between the Bridge connector and the
      database. Typically this is necessary when connecting to
      older databases that either do not support or haven't been
      configured to support transport encryption.
    </p>
  `;
  private label = 'Use transport encryption for this connection (recommended)';
  private inputName = 'data_source[ssl]';

  isChecked(): boolean {
    return this.checked;
  }

  isEnabledForBridgeConnection(): boolean {
    return this.bridged && this.checked && !this.sslOptional;
  }

  isEnabledForDirectConnection(): boolean {
    return !this.bridged && this.checked && !this.sslOptional;
  }

  displayToggle(): boolean {
    return !this.checked || this.sslOptional;
  }
}

export const ConnectionEncryptionToggleComponent: angular.IComponentOptions = {
  controller: ConnectionEncryptionToggleController,
  controllerAs: 'ctrl',
  bindings: {
    checked: '<',
    bridged: '<',
    sslOptional: '<',
  },
  template: `
    <div class="enabled-message enabled-tls" ng-if="ctrl.isEnabledForDirectConnection()">
      <capra-icon class="sm-icon align-top-icon" icon="icon-lock"></capra-icon> Connections between {{ ctrl.appName }} and your database will be encrypted.
    </div>

    <div class="enabled-message enabled-bridge-tls" ng-if="ctrl.isEnabledForBridgeConnection()">
      <capra-icon class="sm-icon align-top-icon" icon="icon-lock"></capra-icon> Connections between the Bridge connector and your database will be encrypted.
    </div>

    <form-toggle-confirm
      checked="ctrl.isChecked()"
      uncheck-confirm-content="ctrl.confirmContent"
      uncheck-confirm-button-confirm="{{ctrl.confirmButtonConfirm}}"
      uncheck-confirm-button-cancel="{{ctrl.confirmButtonCancel}}"
      confirm-on-uncheck="true"
      desc="{{ctrl.desc}}"
      input-name="{{ctrl.inputName}}"
      is-number="true"
      label="{{ctrl.label}}"
      modal-type="${ModalType.Legacy}"
      ng-if="ctrl.displayToggle()"
    />
  `,
};
